import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Tabs from "../../../components/controls/tabs/Tabs";
import TagPanel from "./TagPanel";
import skillService from "../../../store/services/skill.service";
import industryService from "../../../store/services/industry.service";
import { getLocalStorage, keys as localStorageKeys } from "../../../utils/localStorageUtils";
import styles from "./TagLibrary.module.css";

const skillAdapter = {
  getList: skillService.getSkillsRequest,
  create: skillService.createSkillRequest,
  getUsage: skillService.getSkillUsageRequest,
  rename: skillService.renameSkillRequest,
  remove: skillService.deleteSkillRequest,
};

const industryAdapter = {
  getList: industryService.getIndustriesRequest,
  create: industryService.createIndustryRequest,
  getUsage: industryService.getIndustryUsageRequest,
  rename: industryService.renameIndustryRequest,
  remove: industryService.deleteIndustryRequest,
};

const TagLibrary = () => {
  const history = useHistory();
  const isDefaultAdmin = getLocalStorage(localStorageKeys.HAS_DEFAULT_ADMIN_ROLE);
  const [selectedTab, setSelectedTab] = useState("skills");

  useEffect(() => {
    if (!isDefaultAdmin) {
      history.push("/dashboard");
    }
  }, [isDefaultAdmin, history]);

  if (!isDefaultAdmin) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>Tag Library</h4>
      <Tabs
        type="tagLibrary"
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <div className={`${styles.panelWrapper} ${styles.card}`}>
        {selectedTab === "industries" ? (
          <TagPanel
            key="industries"
            service={industryAdapter}
            entityLabel="Industry"
            affectedLabel="Clients"
          />
        ) : (
          <TagPanel
            key="skills"
            service={skillAdapter}
            entityLabel="Skill"
            affectedLabel="Users"
          />
        )}
      </div>
    </div>
  );
};

export default TagLibrary;
